import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

// --- Data Structure based on your image ---
const PRICING_DATA = [
  {
    category: "Einzeltechnik",
    items: [
      { name: "Neumodellage", price: "€ 100" },
      { name: "Auffüllen bis 2 Wochen", price: "€ 40" },
      { name: "Auffüllen bis 3 Wochen", price: "€ 50" },
      { name: "Auffüllen bis 4 Wochen", price: "€ 60" },
    ],
  },
  {
    category: "Wispy Technik",
    items: [
      { name: "Neumodellage Soft Wispy", price: "€ 115" },
      { name: "Auffüllen bis 4 Wochen", price: "€ 65" },
      { name: "Neumodellage Mega Wispy", price: "€ 130" },
      { name: "Auffüllen bis 4 Wochen", price: "€ 70" },
    ],
  },
  {
    category: "Volumentechnik",
    items: [
      { name: "Neumodellage", price: "€ 130" },
      { name: "Auffüllen bis 2 Wochen", price: "€ 50" },
      { name: "Auffüllen bis 3 Wochen", price: "€ 60" },
      { name: "Auffüllen bis 4 Wochen", price: "€ 65" },
    ],
  },
  {
    category: "Lifting",
    items: [
      { name: "Wimpernlaminierung mit Färben", price: "€ 60 / € 65" },
      { name: "Augenbrauenlifting mit Formen & Färben", price: "€ 55 / € 65" },
    ],
  },
];

// --- Styled Components ---

const PricingSection = styled.section`
  padding: 120px 20px;
  /* background-color: #c4b1ae; Matches the warm taupe in your pricing image */
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled(motion.h2)`
  font-family: "Lovelace", serif;
  font-style: italic;
  font-size: clamp(2.5rem, 5vw, 4rem);
  color: #6b5c5b;
  margin-bottom: 60px;
  text-align: center;
`;

const Grid = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(370px, 1fr));
  gap: 30px;
  width: 100%;
  max-width: 1600px;
  @media (max-width: 1600px) {
    grid-template-columns: repeat(auto-fit, minmax(40%, 1fr));
    max-width: 1000px;
  }
  @media (max-width: 800px) {
    grid-template-columns: repeat(auto-fit, minmax(49%, 1fr));
    max-width: 1000px;
  }
`;

const CategoryCard = styled(motion.div)`
  background: rgba(155, 128, 103, 0.15);
  backdrop-filter: blur(10px);
  padding: 50px;
  border-radius: 30px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  display: flex;
  flex-direction: column;
`;

const CategoryName = styled.h3`
  text-transform: uppercase;
  font-size: 1.2rem;
  letter-spacing: 2px;
  color: #665a5a;
  margin-bottom: 30px;
  border-bottom: 1px solid rgba(41, 22, 22, 0.2);
  padding-bottom: 10px;
`;

const PriceItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 25px;
  gap: 20px;

  span:first-child {
    /* font-family: "Georgia", serif; */
    font-size: 1rem;
    color: #2e1a18;
    flex: 1;
  }

  span:last-child {
    font-family: "The Seasons", serif;
    font-weight: bold;
    color: #fff;
    text-shadow: 0px 1px 2px black;
    white-space: nowrap;
  }
`;

// --- Animation Variants ---

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.2 },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut" },
  },
};

// --- Component ---

const LashPricing = () => {
  return (
    <PricingSection>
      <Title
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        Lashes, tailored to you!
      </Title>

      <Grid
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        {PRICING_DATA.map((cat, idx) => (
          <CategoryCard
            key={idx}
            variants={cardVariants}
            whileHover={{
              y: -10,
              backgroundColor: "rgba(255, 255, 255, 0.25)",
            }}
          >
            <CategoryName>{cat.category}</CategoryName>
            {cat.items.map((item, i) => (
              <PriceItem key={i}>
                <span>{item.name}</span>
                <span>{item.price}</span>
              </PriceItem>
            ))}
          </CategoryCard>
        ))}
      </Grid>

      {/* Small extra for "Sonstiges" */}
      <motion.p
        style={{
          marginTop: "40px",
          color: "#ce9f7c",
          fontStyle: "italic",
          opacity: 0.8,
        }}
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 0.8 }}
      >
        Fachgerechte Entfernung der Wimpernextensions: € 20
      </motion.p>
    </PricingSection>
  );
};

export default LashPricing;
